import type { RecipeDto } from '@iac/contracts';
import { useDict } from '../../i18n/dictionary';
import { recipesDict } from './i18n';

/** "4 porcje · 1 h 30 min", or nothing when neither is set. */
export function RecipeMeta({ recipe }: { recipe: RecipeDto }) {
  const t = useDict(recipesDict);
  const parts = [
    recipe.servings !== null && t.servingsCount(recipe.servings),
    recipe.minutes !== null && t.duration(recipe.minutes),
  ].filter((part) => part !== false);
  if (parts.length === 0) return null;
  return <span className="recipe-meta">{parts.join(' · ')}</span>;
}
